import React from 'react';
import Icon from '../../../components/AppIcon';

const TrendingTopics = ({ topics, onTopicClick }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <h3 className="text-sm font-semibold text-card-foreground mb-3 flex items-center space-x-2">
        <Icon name="TrendingUp" size={16} className="text-conversion-accent" />
        <span>Trending Topics</span>
      </h3>
      <div className="space-y-3">
        {topics?.map((topic, index) => (
          <button
            key={topic?.id}
            onClick={() => onTopicClick(topic)}
            className="w-full text-left group premium-hover"
          >
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 mt-1">
                <span className={`inline-flex items-center justify-center w-6 h-6 rounded-full text-xs font-bold ${
                  index === 0 ? 'bg-primary text-primary-foreground' :
                  index === 1 ? 'bg-muted text-muted-foreground' :
                  index === 2 ? 'bg-conversion-accent/20 text-conversion-accent': 'bg-muted/50 text-muted-foreground'
                }`}>
                  {index + 1}
                </span>
              </div>
              
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-card-foreground group-hover:text-primary transition-colors duration-200 line-clamp-2">
                  {topic?.title}
                </p>
                <div className="flex items-center space-x-3 mt-1">
                  <span className="text-xs text-muted-foreground">
                    {topic?.articleCount} articles
                  </span>
                  <div className="flex items-center space-x-1 text-conversion-accent">
                    <Icon name="TrendingUp" size={12} />
                    <span className="text-xs font-medium">+{topic?.growthPercentage}%</span>
                  </div>
                </div>
              </div>
            </div>
          </button>
        ))}
      </div>
      <button className="w-full mt-4 text-sm text-primary hover:text-primary/80 transition-colors duration-200 font-medium">
        View All Trending Topics
      </button>
    </div>
  );
};

export default TrendingTopics;